import PageContainer from "../components/pageContainer/PageContainer";
import SettingsLayout from "../components/settings/SettingsLayout";
import Button from "../components/button";
import { Plus } from "../assets/icons";
import { useEffect, useState } from "react";
import ApiDatabase from "../server";
import UseContext from "../hooks/useContext";
import useModal from "../components/modal/useModal";
import useTitle from "../hooks/TitleManager";
import TeamItem from "../components/teamItem/TeamItem";

const SettingsTeam = () => {
  useTitle({ title: "Paramètres - Equipe" });
  const { modalDataReturn, setModalDataReturn, teams, setTeams } = UseContext();
  const { toggle } = useModal();
  const [isWaiting, setIsWaiting] = useState(false);

  useEffect(() => {
    setIsWaiting(true);
    ApiDatabase.getTeams(
      {},
      (res) => {
        setTeams(res.teams);
        setIsWaiting(false);
      },
      (err) => {
        console.log("err", err);
        setIsWaiting(false);
      },
    );
  }, [setTeams]);

  const handleAddTeam = () => {
    toggle("add_team");
  };

  useEffect(() => {
    if (modalDataReturn.employees) {
      setTeams(modalDataReturn.employees);
      setModalDataReturn({});
    }
  }, [modalDataReturn, setModalDataReturn, setTeams]);

  return (
    <PageContainer type={"settings_team"}>
      <SettingsLayout>
        <div className="flex flex-col gap-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <h1 className="ft-xl font-semibold text-gray-900 pl-4">Équipe</h1>
            <Button color={"PRIMARY"} size={"SM"} onClick={handleAddTeam}>
              <div className={"flex gap-1 items-center"}>
                <Plus wh={20} color={"#FFFFFF"} />
                <span>Inviter un membre</span>
              </div>
            </Button>
          </div>

          <div className="flex flex-col">
            <div className={"grid grid-cols-5 border-b border-gray-100 p-4 text-sm"}>
              <div className={"col-span-3"}>MEMBRES</div>
              <div className={"text-gray-500"}>RÔLE</div>
            </div>
            {isWaiting
              ? [1, 2, 3, 4].map((index) => (
                  <div
                    key={index}
                    className={
                      "grid grid-cols-5 animate-pulse border-b border-gray-100 p-4 text-sm"
                    }
                  >
                    <div className={"col-span-3"}>
                      <div className={"flex gap-6"}>
                        <div className={"h-10 w-10 rounded bg-gray-200"}></div>
                        <div className={"flex flex-col gap-1"}>
                          <div className={"h-4 w-32 rounded bg-gray-200"}></div>
                          <div className={"h-4 w-40 rounded bg-gray-200"}></div>
                        </div>
                      </div>
                    </div>
                    <div className={"flex items-center"}>
                      <div className={"h-4 w-40 rounded bg-gray-200"}></div>
                    </div>
                    <div className={"flex items-center justify-end"}>
                      <div className={"h-8 w-8 rounded bg-gray-200"}></div>
                    </div>
                  </div>
                ))
              : teams.length > 0 &&
                teams.map((team, index) => (
                  <TeamItem team={team} key={index} />
                ))}
          </div>
        </div>
      </SettingsLayout>
    </PageContainer>
  );
};

export default SettingsTeam;
